import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'
import { detectLocale, LOCALE_STORAGE_KEY, translate, type Locale, type Translator } from './translate'

interface I18nContextValue {
  locale: Locale
  setLocale: (locale: Locale) => void
  t: Translator
}

const I18nContext = createContext<I18nContextValue | null>(null)

export function I18nProvider({ children }: { children: ReactNode }) {
  const [locale, updateLocale] = useState<Locale>(detectLocale)
  useEffect(() => {
    document.documentElement.lang = locale
    document.title = translate(locale, 'TOGAPhotos Account')
  }, [locale])

  const setLocale = (next: Locale) => {
    updateLocale(next)
    try { window.localStorage.setItem(LOCALE_STORAGE_KEY, next) }
    catch { /* Keep switching available even when storage is blocked. */ }
  }

  return <I18nContext.Provider value={{ locale, setLocale, t: (source, params) => translate(locale, source, params) }}>
    {children}
  </I18nContext.Provider>
}

export function useI18n(): I18nContextValue {
  const context = useContext(I18nContext)
  if (!context) throw new Error('useI18n must be used within I18nProvider')
  return context
}
